export default "__VITE_ASSET__DC7Vn375__"